/* Logos */
import _Logo from "./logo.jpg";
import logos from "./logo_small.png";
import _dreamlagoonsLogoAra from "./dreamlagoonsara.jpg";
import _logoESR from "./esr.jpg";
import _logoCasasAra from "./casas-ara.jpg";
import _logoConsorciosAra from "./consorcio-ara.jpg";

import _Slider from "./image.jpg";
import _Slider2 from "./slider2.jpg";

import _img1_slide from "./slider/slide1.jpg";
import _img2_slide from "./slider/slide2.jpg";

import _img1_slider_lp from "./slider/full-slider-lp.jpg";

import sliderArrowLeft_ from "./arrow-blue-left.png";
import sliderArrowRight_ from "./arrow-blue-right.png";

/* Temp Images */
import image1_ from "./properties/image.jpg";
import image2_ from "./properties/image2.jpg";
import image3_ from "./properties/image3.jpg";
import image4_ from "./properties/image4.jpg";

import sliderNavImg1_ from "./slider_nav.jpg";

import familiahome_ from "./familia.png";

/* Headers */
import bannercancun01 from "./headers/image.png";
import bannermetepec01 from "./headers/metepecimg.jpg";
import bannermonterrey01 from "./headers/monterreyimg.jpg";
import bannerveracruz01 from "./headers/veracruzimg.jpg";
import banneracapulco01 from "./headers/acapulcoimg.jpg";
import bannercocoyoc01 from "./headers/cocoyocimg.jpg";

/* Amenities Icons */
import construccion from "./amenities/construccion.png";
import estacionamiento from "./amenities/estacionamiento.png";
import precio from "./amenities/precio.png";
import recamaras from "./amenities/recamaras.png";
import vestidor from "./amenities/vestidor.png";
import bano from "./amenities/ba-os.png";

export const Logo = _Logo;
export const logosmall = logos;
export const dreamlagoonsLogoAra = _dreamlagoonsLogoAra;
export const logoEsr = _logoESR;
export const logoCasasAra = _logoCasasAra;
export const logoConsorciosAra = _logoConsorciosAra;

export const Slider = _Slider;
export const Slider2 = _Slider2;

/*  Temp images */
export const image1 = image1_;
export const image2 = image2_;
export const image3 = image3_;
export const image4 = image4_;
export const sliderNavImg1 = sliderNavImg1_;

export const img1_slide = _img1_slide;
export const img2_slide = _img2_slide;
export const img1_slider_lp = _img1_slider_lp;

export const familiahome = familiahome_;

/* Others */
export const bannercancun = bannercancun01;
export const bannermetepec = bannermetepec01;
export const bannermonterrey = bannermonterrey01;
export const bannerveracruz = bannerveracruz01;
export const banneracapulco = banneracapulco01;
export const bannercocoyoc = bannercocoyoc01;

export const construccionIcon = construccion;
export const estacionamientoIcon = estacionamiento;
export const precioIcon = precio;
export const recamarasIcon = recamaras;
export const vestidorIcon = vestidor;
export const banoIcon = bano;

export const sliderArrowLeft = sliderArrowLeft_;
export const sliderArrowRight = sliderArrowRight_;
